import React from 'react'

export default function Banner() {
    return (
        <div className='container-fluid'>
            <div className="row">
                <img className='col-12' src="https://media.indiaistore.com/themes/frontend/images/Home-tile-11pro/Abailable_iPhone-11_desktop.jpg" alt="Banner Image"/>
            </div>
        </div>
    )
}